import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class DataExport extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;

    // State
    this.state = {
      loadingStatus: constants.api.success,
      dataExported: false,
    };

    // Bindings
    this.downloadData = this.downloadData.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  resetState() {
    // Give modal a second to fade out, then reset state.
    setTimeout(() => {
      this.setState({ dataExported: false });
    }, 1000);
  }

  downloadData() {
    this.setState({ loadingStatus: constants.api.loading });

    this.api.dataExport((api) => {
      if (api.status === constants.api.success) {
        // Email sent to user

        this.setState({
          loadingStatus: constants.api.success,
          dataExported: true,
        });
      } else {
        this.setState({ loadingStatus: constants.api.failure });
      }
    });
  }

  render() {
    const failureMessage = this.state.loadingStatus === constants.api.failure ?
      <p className="text-danger">{strings.downloadFailure}</p> : null;

    const initialScreen = (
      <div>
        <div className="modal-body">
          <p>{strings.downloadYourData}</p>
          { failureMessage }
        </div>
        <div className="modal-footer d-block">
          <button type="button" className="btn btn-outline-primary btn-block" onClick={this.downloadData}>
            {strings.download}
          </button>
          <button type="button" className="btn btn-outline-secondary btn-block" data-dismiss="modal">
            {strings.cancel}
          </button>
        </div>
      </div>
    );

    const exportedScreen = (
      <div>
        <div className="modal-body">
          <p>{strings.dataSentSuccessfully}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.resetState}>
            {strings.done}
          </button>
        </div>
      </div>
    );

    const modalBody = this.state.dataExported ? exportedScreen : initialScreen;

    return (
      <div className="modal fade" id="dataExportModal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="data-export--title">{strings.exportAllMyData}</h5>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">{'\u00D7'}</span>
              </button>
            </div>
            { modalBody }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accountManagement/DataExport.jsx